/**
 * The header of a panel inside a page: a tab body, a sub-section. Distinct
 * from PageHeader because a page has exactly one title.
 */
import type { ReactNode } from 'react';

import { Inline, Typography } from './finixt.js';

export interface SectionHeaderProps {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

export function SectionHeader({ title, subtitle, actions }: SectionHeaderProps) {
  return (
    <header
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 11,
      }}
    >
      <div style={{ minWidth: 0, flex: '1 1 240px' }}>
        <Typography variant="heading">{title}</Typography>
        {subtitle ? (
          <Typography
            variant="body-muted"
            as="div"
            style={{ marginTop: 5, maxWidth: '65ch', fontSize: 'var(--text-body-md)' }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </div>
      {actions ? (
        <Inline wrap={false} align="center" style={{ flexShrink: 0 }}>
          {actions}
        </Inline>
      ) : null}
    </header>
  );
}
